import { Component, OnInit, ViewChild } from '@angular/core';
import { ClienteService } from '../services/cliente.service';
import { ListadoClientes } from '../models/viewmodels/listadoClientes';
import { ClienteViewModel } from '../models/viewmodels/clienteViewModel';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router'
import { DoubleBounceComponent } from '../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../shared/custom-alert/custom-alert.component';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  query = new FormControl();
  pagina: number = 0;
  cantidadPorPagina: number = 20;
  listado: ListadoClientes = null;
  paginas: number = 0;
  isLoading = true;

  cliente: ClienteViewModel;
  display:boolean=false;

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;


  constructor(private clienteService: ClienteService, private router: Router) {
    this.listado = new ListadoClientes();
    this.listado.clientes = new Array<ClienteViewModel>();
   }

  ngOnInit() {
    this.obtenerClientes();
    this.query.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(term => {
        if (term.length == 0) {
          this.pagina = 0;
          this.obtenerClientes();
        }else if(term.length > 2){
          this.obtenerClientes();
        }
      });
  }

  obtenerClientes(paginaActual?: number) {
    this.pagina = paginaActual == null ? 0 : paginaActual;
    this.spinner.isRunning = true;
    this.clienteService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(result => {
      this.spinner.isRunning = false;
      this.listado = result;
      if (this.listado && this.listado.total > 0) {
        this.paginas = Math.floor((this.listado.total + this.cantidadPorPagina - 1) / this.cantidadPorPagina);
      }
    });
  }

  anterior() {
    this.obtenerClientes(this.pagina - 1);
  }

  siguiente() {
    this.obtenerClientes(this.pagina + 1);
  }

  buscar() {
    this.obtenerClientes();
  }

  historica(cliente: ClienteViewModel) {
    this.clienteService.setCliente(cliente);
    this.router.navigate(['dashboard/clientes/ctacte/historica'])
  }

  aplicada(cliente: ClienteViewModel) {
    this.clienteService.setCliente(cliente);
    this.router.navigate(['dashboard/clientes/ctacte/aplicada'])
  }

  editar(cliente: ClienteViewModel) {
    this.clienteService.setCliente(cliente);
    this.router.navigate(['dashboard/clientes/editar'])
  }

  reenviar(id: string) {
    this.spinner.isRunning = true;
    this.clienteService.reenviarRegistracion(id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Reenviar mail registración";
      if (result.status == 201) {
        this.alert.tipo = "success"
        this.alert.mensaje = `El email se ha reenviado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "El email no se han podido reenviar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);
      this.spinner.isRunning = false;
    }, error => {
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Reenviar mail registración";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "El email no se han podido reenviar. Por favor vuelva a intentarlo."


    })
  }
  paginate(event) {    
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.obtenerClientes(event.page);
  }


  showDialog(cliente: ClienteViewModel) {
    this.cliente = cliente;
    this.display = true;
  }

  eliminar() {
    this.display = false;
    this.spinner.isRunning = true;
    this.clienteService.eliminar(this.cliente.id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Eliminar cliente";
      if (result.status == 204) {
        this.alert.tipo = "success"
        this.alert.mensaje = `El cliente ${this.cliente.razonSocial} se ha eliminado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "El cliente no se ha podido eliminar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);
      this.listado.clientes = this.listado.clientes.filter(u => {
        return u.id != this.cliente.id
      });
      this.cliente = null;      
      this.spinner.isRunning = false;
    }, error => {      
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Eliminar cliente";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "El cliente no se ha podido eliminar. Por favor vuelva a intentarlo."
      
      
    })
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/clientes/clientes.component.ts